import { useState, useEffect, useContext } from "react";
import MyContext from "../../MyContext";
import { Form, FormControl } from "react-bootstrap";
const Ledger = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [ledgerData, setLedgerData] = useState([]);
  const [interval, setInterval] = useState("30");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading,setLoading]=useState(false);
  const [transactionsPerPage] = useState(100);
  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getOneWeekBackDate = () => {
    const oneWeekBack = new Date();
    oneWeekBack.setDate(oneWeekBack.getDate() - 7);
    const year = oneWeekBack.getFullYear();
    const month = String(oneWeekBack.getMonth() + 1).padStart(2, "0");
    const day = String(oneWeekBack.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getOneDayBackDate = () => {
    const oneDayBack = new Date();
    oneDayBack.setDate(oneDayBack.getDate() - 1); // Subtract 1 day
    const year = oneDayBack.getFullYear();
    const month = String(oneDayBack.getMonth() + 1).padStart(2, "0");
    const day = String(oneDayBack.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
    const [startDateCurrent, setStartDateCurrent] = useState(getOneDayBackDate());
    const [endDateCurrent, setEndDateCurrent] = useState(getCurrentDate());
    const getLedgerDataAPI = async (selectedInterval) => {
        setLoading(true); // start loader
        try {
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      
          var raw = JSON.stringify({
            userid: userID,
        
            fromDate: startDateCurrent,
            toDate: endDateCurrent,
            secret: "string",
          });
      
          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };
      
          const res = await fetch(
            `${baseUrl}/api/Whatsapp/getBillingLedger`,
            requestOptions
          );
          const data = await res.json();
      
          if (data?.responseCode === "00") {
            setLedgerData(data?.data);
          }
        } catch (error) {
          console.error("Error fetching ledger data:", error);
        } finally {
          setLoading(false); // stop loader
        }
      };

  useEffect(() => {
    getLedgerDataAPI(interval);
  }, [startDateCurrent,endDateCurrent]);
 
 
  const indexOfLastTransaction = currentPage * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = ledgerData.slice(
    indexOfFirstTransaction,
    indexOfLastTransaction
  );
  // **Pagination Handlers**
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () =>
    setCurrentPage((prev) =>
      prev < Math.ceil(ledgerData.length / transactionsPerPage)
        ? prev + 1
        : prev
    );
  const prevPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));

  return (
    <div
      className="p-4 bg-white"
      style={{
        fontFamily: "Nunito,sans-serif",
      }}
    >
      <div className="px-4">
        <div className="billing-ledger-section">
         <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="CreateCampaign">Transaction Ledger</h3>
          <div className="d-flex align-items-end gap-3">
  <div>
    <label className="form-label fw-semibold">Start Date</label>
    <FormControl
      type="date"
      value={startDateCurrent}
      className="bg-light"
      onChange={(e) => setStartDateCurrent(e.target.value)}
    />
  </div>

  <div>
    <label className="form-label fw-semibold">End Date</label>
    <FormControl
      type="date"
      value={endDateCurrent}
      className="bg-light"
      onChange={(e) => setEndDateCurrent(e.target.value)}
    />
  </div>
</div>
          </div>
          {/* <div className="billing-filter-section d-flex gap-2 mb-3">
          <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div> */}
     {loading ? (
  <div className="text-center py-4">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
) : (
        <div className="">
  {currentTransactions.length > 0 ? (
    currentTransactions.map((txn, index) => (
      <div key={index} className="card w-100 p-3 mb-3 bg-light">
        <div className="d-flex justify-content-between">
          <div>
            <strong>Transaction Date:</strong>{" "}
            {new Date(txn.transactionDate).toLocaleString()}
          </div>
          <div>
            <strong>Particulars:</strong> {txn.narraton}
          </div>
        </div>

        <div className="d-flex justify-content-between mt-2">
          <div
            className={
              txn.transactionType === "credit"
                ? "billing-text-success fw-bold"
                : "billing-text-danger fw-bold"
            }
          >
            <div>
              <strong>Type:</strong>{" "}
              {txn.transactionType.charAt(0).toUpperCase() +
                txn.transactionType.slice(1)}
            </div>
          </div>
          <div
            className={
              txn.transactionType === "credit"
                ? "billing-text-success fw-bold"
                : "billing-text-danger fw-bold"
            }
          >
            <strong>Amount:</strong> ₹ {parseFloat(txn.transactionAmount).toFixed(2)}
          </div>
        </div>

        <div className="d-flex justify-content-between mt-2">
          <div>
            <strong>Opening Balance:</strong> ₹ {parseFloat(txn.openingBalance).toFixed(2)}
          </div>
          <div>
            <strong>Closing Balance:</strong> ₹ {parseFloat(txn.closingBalance).toFixed(2)}
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="text-center text-muted mt-3">No data found</div>
  )}
</div>
)}

{ledgerData.length > 0 && (
  <div className="billing-pagination d-flex justify-content-center mt-4 flex-wrap gap-2">
    <button
      className="btn btn-outline-primary"
      onClick={prevPage}
      disabled={currentPage === 1}
    >
      Previous
    </button>
    {Array.from(
      { length: Math.ceil(ledgerData.length / transactionsPerPage) },
      (_, index) => (
        <button
          key={index + 1}
          className={`btn ${
            currentPage === index + 1 ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => paginate(index + 1)}
        >
          {index + 1}
        </button>
      )
    )}
    <button
      className="btn btn-outline-primary"
      onClick={nextPage}
      disabled={
        currentPage ===
        Math.ceil(ledgerData.length / transactionsPerPage)
      }
    >
      Next
    </button>
  </div>
)}
        </div>
      </div>
    </div>
  );
};
export default Ledger;
